import { ClassNames } from '@emotion/react';
import React from 'react';
import 'src/components/TopBar/burger/index.css';
import { BurgerContainer } from 'src/styles/topbar';

interface BurgerProps {
  isOpen: boolean;
  onPress: () => void;
}

const Burger: React.FC<BurgerProps> = ({ isOpen, onPress }) => {
  return (
    <ClassNames>
      {({ cx }) => (
        <BurgerContainer onClick={onPress}>
          <div className={cx({ burgerIcon: true, open: isOpen })}>
            <span />
            <span />
            <span />
            <span />
          </div>
        </BurgerContainer>
      )}
    </ClassNames>
  );
};

export default Burger;
